<template>
  <div>
    <hrms-staappr   :staappr='detail.staappr'
                    :nowLang="nowLang"
                    :currentDtereq="setDateOutput(currentDtereq)"
                    :currentNumseq="currentNumseq"
                    :currentCodempid="currentCodempid" />

    <div class="box-func">
      <div class="box-topic border-color-skin">
        <i class="fa fa-envelope margin-r-5 color-skin"></i>
        <label class="color-skin">{{ descCodapp }}</label>
      </div>

      <div class="box-body">

        <div class="row">
            <!-- Adjust -->
            <div class="col-lg-1"></div>

            <!-- group left (Code Leave) -->
            <div class="col-md-4 col-lg-3">
                <div class="row">
                    <!-- Code Leave -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES6MEC1']['30'] }}</label>
                            <div class="input-group">
                                <span class="input-group-addon align-center disabled-icon">
                                    {{ detail.codleave }}
                                </span>
                                <input  class="form-control text-center" id="desc_codleave" name="desc_codleave" v-bind:value="detail.desc_codleave" readonly="readonly">
                            </div>
                        </div>
                    </div>

                    <!-- Type of Leave -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES6MEC2']['250'] }}</label>
                            <div class="row">
                                <div class="form-group clearfix">
                                    <div class="radio col-ms-6 col-sm-6 col-md-12">
                                        <label>
                                            <input type="radio" value="A" readonly="readonly" disabled="disabled" v-model="detail.flgleave" >
                                            {{ labels['HRES6MEC2']['200'] }}
                                        </label>
                                    </div>
                                    <div class="radio col-ms-6 col-sm-6 col-md-12">
                                        <label>
                                            <input type="radio" value="M" readonly="readonly" disabled="disabled" v-model="detail.flgleave" >
                                            {{ labels['HRES6MEC2']['210'] }}
                                        </label>
                                    </div>
                                    <div class="radio col-ms-6 col-sm-6 col-md-12">
                                        <label>
                                            <input type="radio" value="E" readonly="readonly" disabled="disabled" v-model="detail.flgleave" >
                                            {{ labels['HRES6MEC2']['220'] }}
                                        </label>
                                    </div>
                                    <div class="radio col-ms-6 col-sm-6 col-md-12">
                                        <label>
                                            <input type="radio" value="H" readonly="readonly" disabled="disabled" v-model="detail.flgleave" >
                                            {{ labels['HRES6MEC2']['230'] }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- group center (date) -->
            <div class="col-md-4 col-lg-3">
                <div class="row">
                    <!-- From Date -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES6MEC2']['40'] }}</label>
                            <input  class="form-control text-center" id="dtestrt" name="dtestrt" v-bind:value="setDateOutput(detail.dtestrt)" readonly="readonly">
                        </div>
                    </div>

                    <!-- To Date -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES6MEC2']['50'] }}</label>
                            <input  class="form-control text-center" id="dteend" name="dteend" v-bind:value="setDateOutput(detail.dteend)" readonly="readonly">
                        </div>
                    </div>
                </div>
            </div>

            <!-- group right (time) -->
            <div class="col-md-4 col-lg-3">
                <div class="row">
                    <!-- From Time -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES6MEC2']['80'] }}</label>
                            <input  class="form-control text-center" id="timstrt_display" name="timstrt_display" v-bind:value="detail.timstrt" readonly="readonly">
                        </div>
                    </div>

                    <!-- From Time -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES6MEC2']['90'] }}</label>
                            <input  class="form-control text-center" id="timend_display" name="timend_display" v-bind:value="detail.timend" readonly="readonly">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Detail -->
            <div class="col-md-8 col-lg-6">
                <div class="row">
                    <!-- Deslereq -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES6MEC2']['70'] }}</label>
                            <textarea name="deslereq" id="deslereq" maxlength="600" class="form-control" readonly="readonly">{{ detail.deslereq }}</textarea>
                        </div>
                    </div>
                    <!-- Detail Leave -->
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ labels['HRES6MEC2']['60'] }} <span class="red">*</span></label>
                            <textarea   name="desreq"
                                        maxlength="200"
                                        v-model="detail.desreq"
                                        v-validate="'required|max:200'"
                                        data-vv-name="desreq"
                                        class="form-control"
                                        :disabled="!validateStaappr"
                                        :has-error="errors.has('desreq')" />
                            <div class="text-error" v-show="errors.has('desreq')">{{ errors.first('desreq') }}</div>
                            <div class="remark-limit-character">{{ dispLimitLabel(200) }}</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
      </div>

      <div class="box-footer align-center border-color-skin">
          <!-- Sumit Button -->
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
          <button type="button" class="btn bg-color-skin" @click="saveData()" v-if="validateStaappr"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres6me-detail',
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'currentDtereq', 'currentNumseq', 'currentCodempid', 'postHres6meSaveCancel', 'indexSelected', 'nowLang', 'descCodapp', 'searchParams' ],
  watch: {
    'detail.desreq' () {
      this.$validator.validate('desreq', this.detail.desreq).catch(e => {})
    },
    detail () {
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  computed: {
    validateStaappr () {
      let staappr = ''
      if (typeof this.indexSelected.staapprcc !== 'undefined') {
        staappr = this.indexSelected.staapprcc.trim()
      }
      return (staappr === '' || this.indexSelected.staapprcc === 'P' || this.indexSelected.staapprcc === 'C')
    }
  },
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    saveParams () {
      return {
        seqno: '' + this.currentNumseq,
        dtereq: this.currentDtereq,
        desreq: this.detail.desreq,
        // remarkap: this.detail.remarkap,
        codempid: this.currentCodempid,
        codleave: this.detail.codleave,
        dtestrt: this.detail.dtestrt,
        dteend: this.detail.dteend,
        seqnor: this.indexSelected.seqno,
        dtereqr: this.indexSelected.dtereq,
        // codappr: this.detail.codappr,
        // dteappr: this.detail.dteappr,
        numlereq: this.indexSelected.numlereq,
        // codcomp: this.detail.codcomp,
        staappr: this.indexSelected.staapprcc,
        // dteupd: this.detail.dteupd,
        // coduser: this.detail.coduser,
        // approvno: this.detail.approvno,
        // routeno: this.detail.routeno,
        // codinput: this.detail.codinput,
        // dteinput: this.detail.dteinput,
        // dtecancel: this.detail.dtecancel,
        flgleave: this.detail.flgleave,
        // dteleave: this.detail.dteleave,
        timstrt: this.detail.timstrt,
        timend: this.detail.timend,
        // codshift: this.detail.codshift,
        desc_codleave: this.detail.desc_codleave,
        statuscc: this.indexSelected.statuscc
        // dteapph: this.detail.dteapph,
        // flgagency: this.detail.flgagency
      }
    },
    saveData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres6meSaveCancel({ saveParams: this.saveParams(), searchParams: this.searchParams })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?631ca03c